export const MESSAGES_CONTEXT = "messages";

export const MESSAGES_STORAGE_VERSION = "0.3";
